import React, { useRef, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


export default function Modal({ isOpen, children, onModalClose, onModalSave, onModalSubmit, title , dynamicBtn , onDynamicFunc }) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const descriptionElementRef = useRef(null);

    const handleModalClose = () => {
        onModalClose();
    }
    const handleModalSave = () => {
        if (onModalSave) {
            onModalSave();
        }
    }
    const handleModalSubmit = () => {
        if (onModalSubmit) {
            onModalSubmit();
        }
    }
    const handleDynamicFunction = () => {
        if (onDynamicFunc) {
            onDynamicFunc();
        }
    }

    useEffect(() => {
        if (isOpen) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [isOpen]);

    return (
        <React.Fragment>
            <Dialog
                fullScreen={fullScreen}
                open={isOpen}
                onClose={handleModalClose}
                fullWidth={true}
                maxWidth={"md"}
                TransitionComponent={Transition}
            >
                <DialogTitle id="scroll-dialog-title">{title}</DialogTitle>
                <DialogContent dividers={true} ref={descriptionElementRef}>
                    {children}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleModalClose} color={onModalSubmit ? 'error' : 'primary'} >
                        {onModalSubmit ? 'Cancel' : 'Close'}
                    </Button>
                    {onModalSave &&
                        <Button onClick={handleModalSave} variant="outlined" >
                            Save
                        </Button>
                    }
                    {onModalSubmit &&
                        <Button onClick={handleModalSubmit} variant="contained" >
                            Submit
                        </Button>
                    }
                    {onDynamicFunc &&
                        <Button onClick={handleDynamicFunction} variant="contained" >
                            {dynamicBtn}
                        </Button>
                    }

                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}